
import { apiRequest } from "../../apiCall";
import { IGetDashboardSummeryRequest } from "../../types/dashboardSummery/apiRequestTypes";

export const getDashbordSummeryRequest = (params: IGetDashboardSummeryRequest) => apiRequest('CustomerCall.GetSummary',params, '',true)